/* Quick Browse collection page (C1-A Aisle Shelves): aisles, shelves, filters, sort, search, quick add. */
(() => {
  if (customElements.get('qb-collection')) return;
  const EDGES = [0, 10, 20, 40, 60, 100, Infinity];
  const SORTS = [['featured', 'Featured'], ['low', 'Price: Low to High'], ['high', 'Price: High to Low'], ['az', 'Name: A to Z']];
  const SAFE = /^[a-z0-9-]+$/;
  const SVG = 'http://www.w3.org/2000/svg';
  const el = (tag, cls, text) => {
    const n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  };
  const icon = (name) => {
    const svg = document.createElementNS(SVG, 'svg');
    svg.setAttribute('class', 'qbc-ic');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    const use = document.createElementNS(SVG, 'use');
    use.setAttribute('href', '#qbc-ic-' + (SAFE.test(name) ? name : 'other'));
    svg.appendChild(use);
    return svg;
  };
  const btn = (cls, text) => {
    const b = el('button', cls, text);
    b.type = 'button';
    return b;
  };

  class QbCollection extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const S = window.Shopify || {};
      this.root = (S.routes && S.routes.root) || '/';
      this.currency = (S.currency && S.currency.active) || 'USD';
      this.page = parseInt(this.dataset.page, 10) || 8;
      this.shelfMin = parseInt(this.dataset.shelfMin, 10) || 8;
      this.title = this.dataset.title || '';
      try {
        this.json = JSON.parse(this.q('[data-qbc-json]').textContent) || {};
      } catch (e) {
        this.json = {};
      }
      this.cards = Array.from(this.querySelectorAll('[data-card]')).map((n) => ({
        n,
        id: n.dataset.id,
        i: Number(n.dataset.index),
        aisle: n.dataset.aisle,
        name: n.dataset.aisleName,
        icon: n.dataset.icon,
        pets: n.dataset.pets || '',
        price: Number(n.dataset.price),
        sale: n.dataset.sale === '1',
        usa: n.dataset.usa === '1',
        text: n.dataset.search || '',
        title: (n.querySelector('.qbc-card__title') || {}).textContent || ''
      }));
      this.N = this.cards.length;
      this.s = { aisle: 'all', pets: [], band: '', sale: false, usa: false, q: '', sort: 'featured', shown: this.page };
      this.grid = this.q('[data-grid]');
      this.pool = this.q('[data-pool]');
      this.shelvesEl = this.q('[data-shelves]');
      this.sheet = this.q('[data-sheet]');
      this.input = this.q('[data-search-input]');
      this.setup();
      this.render();
      this.classList.add('is-ready');
    }

    q(sel) {
      return this.querySelector(sel);
    }

    money(cents, whole) {
      try {
        const o = { style: 'currency', currency: this.currency };
        if (whole) o.maximumFractionDigits = 0;
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', o).format(cents / 100);
      } catch (e) {
        return '$' + (cents / 100).toFixed(whole ? 0 : 2);
      }
    }

    setup() {
      const map = new Map();
      this.cards.forEach((c) => {
        if (!map.has(c.aisle)) map.set(c.aisle, { id: c.aisle, name: c.name, icon: c.icon, count: 0, first: c.i });
        map.get(c.aisle).count++;
      });
      this.aisles = Array.from(map.values()).sort((a, b) => b.count - a.count || a.first - b.first);

      this.bands = [];
      for (let i = 0; i < EDGES.length - 1; i++) {
        const lo = EDGES[i] * 100;
        const hi = EDGES[i + 1] * 100;
        const count = this.cards.filter((c) => c.price >= lo && c.price < hi).length;
        if (!count) continue;
        const label = i === 0 ? 'Under ' + this.money(hi, true) : hi === Infinity ? this.money(lo, true) + ' and up' : this.money(lo, true) + ' to ' + this.money(hi, true);
        this.bands.push({ id: 'b' + i, lo, hi, count, label });
      }

      const row = this.q('[data-aisles]');
      if (row && this.aisles.length > 1) {
        row.textContent = '';
        [{ id: 'all', name: 'Everything', icon: 'all', count: this.N }].concat(this.aisles).forEach((a) => {
          const b = btn('qbc-aisle qbc-tone--' + (SAFE.test(a.icon) ? a.icon : 'other'));
          b.dataset.aisle = a.id;
          b.setAttribute('aria-label', a.name + ', ' + a.count + (a.count === 1 ? ' item' : ' items'));
          b.appendChild(icon(a.icon));
          const t = el('span', 'qbc-aisle__text');
          t.appendChild(el('span', 'qbc-aisle__name', a.name));
          t.appendChild(el('span', 'qbc-aisle__count', a.count + (a.count === 1 ? ' item' : ' items')));
          b.appendChild(t);
          b.addEventListener('click', () => this.set({ aisle: a.id }));
          row.appendChild(b);
        });
        row.hidden = false;
      }

      this.querySelectorAll('[data-open]').forEach((b) => b.addEventListener('click', () => this.openSheet(b.dataset.open)));
      this.querySelectorAll('[data-clear]').forEach((b) => b.addEventListener('click', () => this.clear()));
      const tog = this.q('[data-search-toggle]');
      const box = this.q('[data-search]');
      if (tog && box) {
        tog.addEventListener('click', () => {
          const open = box.hidden;
          box.hidden = !open;
          tog.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (open) this.input.focus();
        });
      }
      if (this.input) this.input.addEventListener('input', () => this.set({ q: this.input.value }));
      const more = this.q('[data-more-btn]');
      if (more) more.addEventListener('click', () => this.set({ shown: this.s.shown + this.page }));
      const vc = this.q('[data-view-cart]');
      if (vc) vc.addEventListener('click', () => this.viewCart());
      this.q('[data-close]').addEventListener('click', () => this.closeSheet());
      this.sheet.addEventListener('click', (e) => {
        if (e.target === this.sheet) this.closeSheet();
      });
      this.addEventListener('click', (e) => {
        const add = e.target.closest('[data-add]');
        if (add && this.contains(add)) {
          this.add(add.dataset.add, add.dataset.name || '', add);
          return;
        }
        const opt = e.target.closest('[data-options]');
        if (opt && this.contains(opt)) this.openSheet('options', opt.dataset.options);
      });
    }

    set(patch) {
      const filterKeys = ['aisle', 'pets', 'band', 'sale', 'usa', 'q', 'sort'];
      Object.assign(this.s, patch);
      if (!('shown' in patch) && Object.keys(patch).some((k) => filterKeys.indexOf(k) > -1)) this.s.shown = this.page;
      if ('q' in patch && this.input && this.input.value !== this.s.q) this.input.value = this.s.q;
      this.render();
      if (this.sheet.open && this.sheetType === 'filter') this.renderSheet();
    }

    clear() {
      this.set({ aisle: 'all', pets: [], band: '', sale: false, usa: false, q: '' });
    }

    filtered() {
      const s = this.s;
      const ql = s.q.trim().toLowerCase();
      const band = this.bands.find((b) => b.id === s.band);
      const list = this.cards.filter(
        (c) =>
          (s.aisle === 'all' || c.aisle === s.aisle) &&
          (!s.pets.length || s.pets.some((k) => c.pets.indexOf(k) > -1)) &&
          (!band || (c.price >= band.lo && c.price < band.hi)) &&
          (!s.sale || c.sale) &&
          (!s.usa || c.usa) &&
          (!ql || c.text.indexOf(ql) > -1)
      );
      if (s.sort === 'low') list.sort((a, b) => a.price - b.price || a.i - b.i);
      else if (s.sort === 'high') list.sort((a, b) => b.price - a.price || a.i - b.i);
      else if (s.sort === 'az') list.sort((a, b) => a.title.localeCompare(b.title));
      return list;
    }

    chips() {
      const s = this.s;
      const out = [];
      if (s.aisle !== 'all') {
        const a = this.aisles.find((x) => x.id === s.aisle);
        out.push([a ? a.name : s.aisle, { aisle: 'all' }]);
      }
      s.pets.forEach((k) => out.push([k === 'd' ? 'Dogs' : 'Cats', { pets: s.pets.filter((x) => x !== k) }]));
      const band = this.bands.find((b) => b.id === s.band);
      if (band) out.push([band.label, { band: '' }]);
      if (s.sale) out.push(['On sale', { sale: false }]);
      if (s.usa) out.push(['Made in USA', { usa: false }]);
      if (s.q.trim()) out.push(['"' + s.q.trim() + '"', { q: '' }]);
      return out;
    }

    render() {
      const s = this.s;
      const list = this.filtered();
      const chips = this.chips();
      const big = this.aisles.filter((a) => a.count >= 2);
      const shelves = chips.length === 0 && s.sort === 'featured' && big.length >= 2 && this.N > this.shelfMin;
      this.cards.forEach((c) => this.pool.appendChild(c.n));
      this.shelvesEl.textContent = '';
      if (shelves) {
        const small = this.aisles.filter((a) => a.count < 2).map((a) => a.id);
        big.forEach((a) => this.shelvesEl.appendChild(this.shelf(a.name, a.icon, list.filter((c) => c.aisle === a.id), a.id)));
        const rest = list.filter((c) => small.indexOf(c.aisle) > -1);
        if (rest.length) this.shelvesEl.appendChild(this.shelf('More in ' + this.title, 'all', rest, null));
      } else {
        list.slice(0, s.shown).forEach((c) => this.grid.appendChild(c.n));
      }
      this.shelvesEl.hidden = !shelves;
      this.grid.hidden = shelves || list.length === 0;
      this.q('[data-empty]').hidden = list.length > 0;

      const shownN = Math.min(s.shown, list.length);
      this.q('[data-more]').hidden = shelves || list.length <= this.page;
      this.q('[data-more-text]').textContent = 'Showing ' + shownN + ' of ' + list.length;
      this.q('[data-progress]').style.width = (list.length ? Math.round((shownN / list.length) * 100) : 0) + '%';
      this.q('[data-more-btn]').hidden = shownN >= list.length;

      this.q('[data-count]').textContent =
        list.length === this.N ? this.N + (this.N === 1 ? ' product' : ' products') : list.length + ' of ' + this.N + ' products';
      const fc = chips.length - (s.q.trim() ? 1 : 0);
      const badge = this.q('[data-filter-n]');
      badge.textContent = String(fc);
      badge.hidden = fc === 0;

      const wrap = this.q('[data-chips]');
      wrap.textContent = '';
      chips.forEach(([label, patch]) => {
        const b = btn('qbc-chip');
        b.setAttribute('aria-label', 'Remove filter: ' + label);
        b.appendChild(el('span', null, label));
        b.appendChild(icon('x'));
        b.addEventListener('click', () => this.set(patch));
        wrap.appendChild(b);
      });
      if (chips.length) {
        const c = btn('qbc-chip-clear', 'Clear all');
        c.addEventListener('click', () => this.clear());
        wrap.appendChild(c);
      }
      wrap.hidden = chips.length === 0;
      this.querySelectorAll('.qbc-aisle').forEach((b) => b.setAttribute('aria-pressed', b.dataset.aisle === s.aisle ? 'true' : 'false'));
    }

    shelf(name, iconName, items, aisleId) {
      const sec = el('section', 'qbc-shelf');
      const head = el('div', 'qbc-shelf__head');
      const h = el('h2', 'qbc-shelf__title');
      const ic = el('span', 'qbc-shelf__icon qbc-tone--' + (SAFE.test(iconName) ? iconName : 'other'));
      ic.appendChild(icon(iconName));
      h.appendChild(ic);
      h.appendChild(el('span', null, name));
      head.appendChild(h);
      if (aisleId) {
        const b = btn('qbc-link');
        b.setAttribute('aria-label', 'See all ' + items.length + ' in ' + name);
        b.appendChild(el('span', null, 'See all ' + items.length));
        b.appendChild(icon('chev'));
        b.addEventListener('click', () => {
          this.set({ aisle: aisleId });
          const anchor = this.q('[data-anchor]');
          if (anchor) anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        head.appendChild(b);
      }
      sec.appendChild(head);
      const rail = el('ul', 'qbc-rail');
      rail.setAttribute('role', 'list');
      items.forEach((c) => rail.appendChild(c.n));
      sec.appendChild(rail);
      return sec;
    }

    async add(id, label, button) {
      if (button) button.setAttribute('aria-busy', 'true');
      try {
        const sections = Array.from(document.querySelectorAll('cart-items-component[data-section-id]')).map((n) => n.dataset.sectionId);
        const res = await fetch(this.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections: sections.join(',') })
        });
        const json = await res.json();
        if (json.status) {
          this.toast(json.description || json.message || 'Could not add to cart.', false);
          return false;
        }
        const cart = await (await fetch(this.root + 'cart.js')).json();
        const drawer = document.querySelector('cart-drawer-component');
        const auto = drawer && drawer.hasAttribute('auto-open');
        if (auto) drawer.removeAttribute('auto-open');
        const ev = new Event('cart:update', { bubbles: true });
        ev.detail = { resource: cart, sourceId: 'qb-collection', data: { source: 'qb-collection', itemCount: cart.item_count, sections: json.sections || {} } };
        this.dispatchEvent(ev);
        if (auto) drawer.setAttribute('auto-open', '');
        if (button && button.dataset.add) {
          button.textContent = 'Added';
          button.classList.add('is-added');
        }
        this.toast('Added: ' + label, true);
        return true;
      } catch (e) {
        this.toast('Could not add to cart. Please try again.', false);
        return false;
      } finally {
        if (button) button.removeAttribute('aria-busy');
      }
    }

    toast(text, ok) {
      const t = this.q('[data-toast]');
      this.q('[data-toast-text]').textContent = text;
      this.q('[data-view-cart]').hidden = !ok;
      t.hidden = false;
      clearTimeout(this.toastTimer);
      this.toastTimer = setTimeout(() => { t.hidden = true; }, 3500);
    }

    viewCart() {
      this.q('[data-toast]').hidden = true;
      const drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') drawer.open();
      else window.location.href = this.root + 'cart';
    }
  }

  QbCollection.h = { el, icon, btn, SAFE, SORTS };
  customElements.define('qb-collection', QbCollection);
})();